<button #button class="dgoods-button" (click)="onClick()" [disabled]="disabled">
    <ng-content></ng-content>
</button>
